import BordSelectStatus from 'components/NudosComponents/BordSelectStatus/BordSelectStatus';
import { STATUS_VARIANTS } from 'components/NudosComponents/BordStatus/BordStatus.type';
import { IQuoteStatus, QUOTE_STATUS_CODE } from 'types/quoteDetails.types';
import './QuoteStatusSelector.scss';

interface IQuoteStatusSelector {
  quoteStatus?: IQuoteStatus;
  onCancelSelect?: () => void;
}

/**
 * Selector de estado de cotización. Muestra el estado actual y permite cambiar a otro estado disponible.
 */
const QuoteStatusSelector = ({ quoteStatus, onCancelSelect }: IQuoteStatusSelector) => {
  const toQuoteCodes = [QUOTE_STATUS_CODE.PENDING, QUOTE_STATUS_CODE.TO_QUOTE];
  const pendingApprovalCodes = [
    QUOTE_STATUS_CODE.PENDING_APPROVAL,
    QUOTE_STATUS_CODE.APPROVED,
    QUOTE_STATUS_CODE.PARTIAL_APPROVED
  ];
  const expiredCodes = [QUOTE_STATUS_CODE.EXPIRED, QUOTE_STATUS_CODE.REJECTED];
  const editableCodes = toQuoteCodes;
  const isDropdownDisabled = !editableCodes.includes(quoteStatus?.code as QUOTE_STATUS_CODE);

  const statusItems = [
    { label: 'Por cotizar', value: QUOTE_STATUS_CODE.TO_QUOTE, variant: STATUS_VARIANTS.alert, hideFromDropdown: true },
    {
      label: 'Pendiente de aprobación',
      value: QUOTE_STATUS_CODE.PENDING_APPROVAL,
      variant: STATUS_VARIANTS.informative,
      hideFromDropdown: true
    },
    { label: 'Comprada', value: QUOTE_STATUS_CODE.PURCHASED, variant: STATUS_VARIANTS.success, hideFromDropdown: true },
    { label: 'Vencida', value: QUOTE_STATUS_CODE.EXPIRED, variant: STATUS_VARIANTS.danger, hideFromDropdown: true },
    { label: 'Cancelada', value: QUOTE_STATUS_CODE.CANCELLED, variant: STATUS_VARIANTS.danger, hideFromDropdown: true },
    { label: 'Cancelar', value: 'CANCEL_ACTION', variant: STATUS_VARIANTS.danger }
  ];

  const currentValue = toQuoteCodes.includes(quoteStatus?.code as QUOTE_STATUS_CODE)
    ? QUOTE_STATUS_CODE.TO_QUOTE
    : pendingApprovalCodes.includes(quoteStatus?.code as QUOTE_STATUS_CODE)
    ? QUOTE_STATUS_CODE.PENDING_APPROVAL
    : expiredCodes.includes(quoteStatus?.code as QUOTE_STATUS_CODE)
    ? QUOTE_STATUS_CODE.EXPIRED
    : quoteStatus?.code;

  const handleChange = (value: string) => {
    if (value === 'CANCEL_ACTION') onCancelSelect?.();
  };

  return (
    <BordSelectStatus
      items={statusItems}
      value={currentValue}
      onChange={handleChange}
      disableDropdown={isDropdownDisabled}
      customDropdownClassName="quoteStatusSelectorDropdown"
    />
  );
};

export default QuoteStatusSelector;
